import React, { ReactElement } from 'react';
import { Intl } from '@erecruit/core';
import { MatchRecordSection } from './types';

const { FormattedMessage } = Intl;

interface ModalHeaderProps {
  title: ReactElement;
  description: ReactElement;
}

export const modalHeaders: Record<MatchRecordSection, ModalHeaderProps> = {
  general: { title: <></>, description: <></> },
  billing: { title: <></>, description: <></> },
  schedule: { title: <></>, description: <></> },
  people: { title: <></>, description: <></> },
  steps: { title: <></>, description: <></> },
  actions: { title: <></>, description: <></> },
  attachments: { title: <></>, description: <></> },
  approvalPath: { title: <></>, description: <></> },
  approvalRejectionReasons: { title: <></>, description: <></> },
  matchStatus: { title: <></>, description: <></> },
  additionalInfo: {
    title: (
      <FormattedMessage id={messageIds.vms.matchRecord.additionalInfo.title} />
    ),
    description: (
      <FormattedMessage
        id={messageIds.vms.matchRecord.additionalInfo.disclaimer}
      />
    ),
  },
};
